import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';
import { LevelHierarchyDepth } from 'src/app/utils/utils';

@Component({
    selector: 'addlevel',
    templateUrl: './addlevel.component.html',
    styleUrls: ['../../../../../style/custom-mat-dialog.component.less'],
    standalone: false
})
export class AddLevelComponent implements OnInit {
    @Output() levelInitializedTrigger = new EventEmitter<EquipmentConfigurationLevel>();

    environments: SelectList[] = [];
    tenants: SelectList[] = [];
    branches: SelectList[] = [];

    public formGroup: FormGroup;

    constructor(
        private readonly dialogRef: MatDialogRef<AddLevelComponent>,
        private readonly defaults: DefaultValuesService,
        private readonly fb: FormBuilder,
        private readonly emtConfigurationService: EquipmentManagenementService,
        private readonly toastService: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: { maxDepth: LevelHierarchyDepth }) {
        this.formGroup = this.fb.group({
            environment: [null, Validators.required],
            tenant: [null],
            branch: [null],
            deviceId: [""]
        });
    }

    ngOnInit() {
        this.environments = this.defaults.environments.map(x => {
            return {
                value: x.toUpperCase(),
                text: x.toUpperCase()
            };
        });
    }

    onDeviceIdChange(event: any) {
        const deviIdValue = event.target.value;
        const branchControl = this.formGroup.get('branch');
        if (deviIdValue && deviIdValue.length > 0) {
            branchControl?.setValidators(Validators.required);
        }
        else {
            branchControl?.clearValidators();
        }
        branchControl?.updateValueAndValidity();
    }

    closeDialog(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }

    public onEnvironmentChanged($event: any) {
        this.tenants = this.emtConfigurationService.getTenantsByEnvironment($event.value, this.defaults.tenants)
    }

    onTenantChanged($event: any) {
        this.branches = this.defaults.branches
            .filter(x => x.Country === $event.value)
            .map(x => {
                return {
                    value: x.Number,
                    text: x.Branch + ' - ' + x.Number
                }
            });
    }

    onSubmit() {
        if (this.formGroup.valid) {
            this.saveLevel();
        }
    }

    private saveLevel() {
        const newLevel = this.createFormRequest();
        this.emtConfigurationService.initEquipmentConfiguration(
            newLevel,
            result => {
                this.levelInitializedTrigger.emit(newLevel);
                this.dialogRef.close();
            },
            error => {
                if (error.status === 409) {
                    this.toastService.warning(error.error)
                }
                else {
                    this.toastService.error("Unable to save new level.");
                }
            }
        );
    }

    private createFormRequest(): EquipmentConfigurationLevel {
        const newLevel: EquipmentConfigurationLevel = {
            environment: this.formGroup.get('environment')!.value,
            tenantId: this.formGroup.get('tenant')?.value,
            branchNumber: this.formGroup.get('branch')?.value,
            deviceId: this.formGroup.get('deviceId')?.value?.trim()
        }
        return newLevel;
    }

}
